export default __webpack_public_path__ + "static/media/opa.e282a847.svg";